export var JobType;
(function (JobType) {
    JobType["TANGANY_TOKEN_REFRESH_CUSTODY"] = "TANGANY_TOKEN_REFRESH_CUSTODY";
    JobType["TANGANY_TOKEN_REFRESH_CUSTOMERS"] = "TANGANY_TOKEN_REFRESH_CUSTOMERS";
    JobType["KYC_STATUS_CHECK"] = "KYC_STATUS_CHECK";
    JobType["KYC_PROCESSING"] = "KYC_PROCESSING";
    JobType["KYC_STALE_RECONCILE"] = "KYC_STALE_RECONCILE";
    JobType["RESIDENCE_VISION_CHECK"] = "RESIDENCE_VISION_CHECK";
    JobType["CRYPTO_PROVISIONING"] = "CRYPTO_PROVISIONING";
    JobType["PAYCENTER_REGISTRATION"] = "PAYCENTER_REGISTRATION";
    JobType["PAYCENTER_JOB_POLL"] = "PAYCENTER_JOB_POLL";
    JobType["PAYCENTER_CARD_PROPERTIES_SYNC"] = "PAYCENTER_CARD_PROPERTIES_SYNC";
    JobType["TRANSACTION_STATUS_POLL"] = "TRANSACTION_STATUS_POLL";
    JobType["TRANSACTION_PROCESSING"] = "TRANSACTION_PROCESSING";
    JobType["EXPIRED_SESSION_CLEANUP"] = "EXPIRED_SESSION_CLEANUP";
    JobType["RATE_LIMIT_RESET"] = "RATE_LIMIT_RESET";
    JobType["ANALYTICS_AGGREGATION"] = "ANALYTICS_AGGREGATION";
    JobType["CRYPTO_PRICE_FETCH"] = "CRYPTO_PRICE_FETCH";
    JobType["BTCDIRECT_SELL_PROCESSING"] = "BTCDIRECT_SELL_PROCESSING";
    JobType["BTCDIRECT_TOKEN_REFRESH"] = "BTCDIRECT_TOKEN_REFRESH";
    JobType["TRADEVEST_TOKEN_REFRESH"] = "TRADEVEST_TOKEN_REFRESH";
    JobType["TRADEVEST_ONBOARDING_START"] = "TRADEVEST_ONBOARDING_START";
    JobType["TRADEVEST_ONBOARDING_POLL"] = "TRADEVEST_ONBOARDING_POLL";
    JobType["TRADEVEST_PORTFOLIO_SNAPSHOT"] = "TRADEVEST_PORTFOLIO_SNAPSHOT";
    JobType["TRADEVEST_ASSET_CATALOG_REFRESH"] = "TRADEVEST_ASSET_CATALOG_REFRESH";
    JobType["TRADEVEST_PROVIDER_LINK_SYNC"] = "TRADEVEST_PROVIDER_LINK_SYNC";
    JobType["ISSUER_CATALOG_SYNC"] = "ISSUER_CATALOG_SYNC";
    JobType["TRADEVEST_EX_ANTE_ARCHIVE"] = "TRADEVEST_EX_ANTE_ARCHIVE";
    JobType["TRADEVEST_DEPOSITORY_RECONCILE"] = "TRADEVEST_DEPOSITORY_RECONCILE";
    JobType["TRADEVEST_CORPORATE_ACTION_RECONCILE"] = "TRADEVEST_CORPORATE_ACTION_RECONCILE";
    JobType["TRADEVEST_UNDELIVERED_WEBHOOK_DRAIN"] = "TRADEVEST_UNDELIVERED_WEBHOOK_DRAIN";
    JobType["TRADEVEST_ORDER_EMAIL"] = "TRADEVEST_ORDER_EMAIL";
    JobType["TRADEVEST_ORDER_EMAIL_SWEEP"] = "TRADEVEST_ORDER_EMAIL_SWEEP";
    JobType["ORDER_PHYSICAL_CARD"] = "ORDER_PHYSICAL_CARD";
    JobType["TRANSACTION_QUEUE_PROCESSOR"] = "TRANSACTION_QUEUE_PROCESSOR";
    JobType["PUSH_NOTIFICATION"] = "PUSH_NOTIFICATION";
    JobType["PUSH_NOTIFICATION_RECEIPT_CHECK"] = "PUSH_NOTIFICATION_RECEIPT_CHECK";
    JobType["PDF_GENERATION"] = "PDF_GENERATION";
    JobType["CARD_EXPIRATION_CHECK"] = "CARD_EXPIRATION_CHECK";
    JobType["TRADEVEST_WEBHOOK_REGISTRATION"] = "TRADEVEST_WEBHOOK_REGISTRATION";
    JobType["PENDING_DOWNGRADE_PROCESSOR"] = "PENDING_DOWNGRADE_PROCESSOR";
    JobType["STANDING_ORDER_GENERATOR"] = "STANDING_ORDER_GENERATOR";
    JobType["TRANSACTION_QUEUE_CLEANUP"] = "TRANSACTION_QUEUE_CLEANUP";
    JobType["CHARGE_INQUIRY_RETRY"] = "CHARGE_INQUIRY_RETRY";
    JobType["SUBSCRIPTION_AUTO_BILLING"] = "SUBSCRIPTION_AUTO_BILLING";
    JobType["NOTIFICATION_PROCESSOR"] = "NOTIFICATION_PROCESSOR";
    JobType["NOTIFICATION_TRIGGER_EVALUATOR"] = "NOTIFICATION_TRIGGER_EVALUATOR";
    JobType["NOTIFICATION_SCHEDULE_PROCESSOR"] = "NOTIFICATION_SCHEDULE_PROCESSOR";
    JobType["REFERRAL_QUALIFICATION_CHECK"] = "REFERRAL_QUALIFICATION_CHECK";
    JobType["THREE_DS_TIMEOUT"] = "THREE_DS_TIMEOUT";
    JobType["FINAPI_TOKEN_REFRESH"] = "FINAPI_TOKEN_REFRESH";
    JobType["FINAPI_CONSENT_RECONCILE"] = "FINAPI_CONSENT_RECONCILE";
    JobType["FINAPI_WEBFORM_RECONCILE"] = "FINAPI_WEBFORM_RECONCILE";
    JobType["FINAPI_CONNECTION_FINALIZE_SWEEP"] = "FINAPI_CONNECTION_FINALIZE_SWEEP";
    JobType["FINAPI_PAYMENT_STATUS_POLL"] = "FINAPI_PAYMENT_STATUS_POLL";
    JobType["FINAPI_AUDIT_LOG_RETENTION"] = "FINAPI_AUDIT_LOG_RETENTION";
    JobType["FINAPI_DELETION_CLEANUP"] = "FINAPI_DELETION_CLEANUP";
    JobType["FINAPI_RECONCILE"] = "FINAPI_RECONCILE";
    JobType["SPARPLAN_AUTOBUY"] = "SPARPLAN_AUTOBUY";
    JobType["SPARPLAN_ORDER_STATUS_POLL"] = "SPARPLAN_ORDER_STATUS_POLL";
    JobType["SPARPLAN_FINALIZE_SWEEP"] = "SPARPLAN_FINALIZE_SWEEP";
    JobType["TRADEVEST_DEPOSIT_RECONCILE"] = "TRADEVEST_DEPOSIT_RECONCILE";
})(JobType || (JobType = {}));
export var JobPriority;
(function (JobPriority) {
    JobPriority[JobPriority["LOW"] = 10] = "LOW";
    JobPriority[JobPriority["NORMAL"] = 5] = "NORMAL";
    JobPriority[JobPriority["HIGH"] = 3] = "HIGH";
    JobPriority[JobPriority["CRITICAL"] = 1] = "CRITICAL";
})(JobPriority || (JobPriority = {}));
//# sourceMappingURL=scheduler.types.js.map